import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import Box from '@mui/material/Box';
function FlexContainer(_a) {
    var { direction = 'column', gap = 4, children } = _a, rest = __rest(_a, ["direction", "gap", "children"]);
    return (_jsx(Box, Object.assign({ display: "flex", flexDirection: direction, gap: gap }, rest, { children: children })));
}
export default FlexContainer;
